module.exports = __webpack_public_path__ + "static/media/lkw-training.45707fb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/lkw-training.svg
// module id = 905
// module chunks = 0